"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadingOptions = exports.default = void 0;
exports.useImageLoading = useImageLoading;
var _reactIntersectionObserver = require("react-intersection-observer");
const loadingOptions = exports.loadingOptions = Object.freeze({
  LAZY: 'lazy',
  EAGER: 'eager',
  MANUAL: 'manual'
});

/**
 * Custom hook for unified image loading logic
 * Handles Intersection Observer for lazy loading
 *
 * @param {Object} options Configuration options
 * @param {string} options.loading Loading mode: 'lazy', 'eager', or 'manual'
 * @param {string} options.rootMargin Root margin for Intersection Observer
 * @param {number} options.threshold Threshold for Intersection Observer
 * @param {boolean} options.initialInView Whether element starts in view
 * @param {boolean} options.show Whether element is visible (for manual mode)
 * @returns {Object} Loading state and control objects
 */
function useImageLoading({
  loading = loadingOptions.LAZY,
  rootMargin = '200px 0px',
  threshold = 0,
  initialInView = false,
  show = null
} = {}) {
  const {
    ref,
    inView
  } = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true,
    rootMargin,
    threshold,
    initialInView: initialInView || loading === loadingOptions.EAGER
  });
  const getLoadingState = () => {
    switch (loading) {
      case loadingOptions.EAGER:
        return true;
      case loadingOptions.MANUAL:
        return show !== null ? show : inView;
      default:
        return inView;
    }
  };
  const shouldLoad = getLoadingState();
  return {
    ref,
    shouldLoad,
    getImageSrc: (url, placeholderSrc = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7') => {
      return inView ? {
        src: url
      } : {
        'data-src': url,
        'src': placeholderSrc
      };
    }
  };
}
var _default = exports.default = useImageLoading;